import { FormControl, FormControlLabel, FormHelperText, FormLabel, Radio, RadioGroup } from "@mui/material"
import { Controller, useFormContext } from "react-hook-form"

export default function RadioSimplesSimOuNao<T extends Object>({
    valoresIniciais,
    nomeForm,
    nomeCampo
}: SelectSimplesSimOuNaoProps<T>) {

    const { control, getFieldState, getValues } = useFormContext()

    //Valores importantes
    const valoresSelect = [{ value: 'N', label: 'Não' }, { value: 'S', label: 'Sim' }]
    //
    return (
        <Controller
            name={nomeForm as string}
            control={control}
            rules={{ required: 'Campo obrigatório' }}
            render={({ field }) => (
                <FormControl fullWidth {...field} error={getFieldState(nomeForm as string).invalid}>
                    <FormLabel id={`${nomeForm as string}-radio`}>{nomeCampo}*</FormLabel>

                    <RadioGroup
                        row
                        aria-labelledby="radioSimOuNao"
                        value={getValues(nomeForm as string)}
                        onChange={(e) => field.onChange(e.target.checked)}
                    >
                        {
                            valoresSelect.map((opcao, index) => (
                                <FormControlLabel key={index} value={opcao.value} control={<Radio />} label={opcao.label} />
                            ))
                        }
                    </RadioGroup>
                    {getFieldState(nomeForm as string).error && (
                        <FormHelperText>{getFieldState(nomeForm as string).error?.message}</FormHelperText>
                    )}
                </FormControl>
            )}
        />
    )
}

interface SelectSimplesSimOuNaoProps<T> {
    valoresIniciais: T | null
    nomeForm: keyof T
    nomeCampo: string
}